import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import decryptJWT from '../../../utils/decryptJWT';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';

export default function SelectServico(props) {
    
    const [spinAtivo, setSpinAtivo] = useState(false);
    
    const [lsServico, setLsServico] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleServico(codigoServico, NomeServico,codigoTipo, nomeTipo,codigoCategoria, nomeCategoria,codigoUnidade, nomeUnidade,quantidade, valor){
        props.setCdServico(codigoServico)
        props.setDsServico(NomeServico)
        props.setCdTipo(codigoTipo)
        props.setDsTipo(nomeTipo)
        props.setCdCategoria(codigoCategoria)
        props.setDsCategoria(nomeCategoria)
        props.setCdUnidade(codigoUnidade)
        props.setDsUnidade(nomeUnidade)
        props.setDsQuantidade(quantidade)
        props.setDsValor(valor)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectServico(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderServico(){
            const {data} = await api_gateway.get('/m1/consultar/fat_servico?cd_pav_usuario='+decryptJWT('codigo'));
            if(data.dados.length > 0){
                let objetoServico = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_fat_servico}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleServico(item.cd_fat_servico, item.ds_fat_servico,
                                item.cd_fat_tipo, item.ds_tipo,item.cd_fat_categoria, item.ds_categoria,item.cd_fat_unidade, item.ds_unidade,item.ds_quantidade, item.n2_valor) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_fat_servico}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsServico(objetoServico)
            }else{
                let objetoServico = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsServico(objetoServico)
            }
            setSpinAtivo(false)
        }
        renderServico()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectServico(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsServico}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsServico}
                </ul>
            </div>
        </Form>
    )
}